module.exports = __webpack_public_path__ + "static/media/people06.19e43989.png";